import { useEffect, useState, useCallback } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2, Clock } from "lucide-react";
import { Button } from "../components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResult() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const pid = params.get("pid");
  const [payment, setPayment] = useState(null);
  const [tries, setTries] = useState(0);

  const poll = useCallback(async () => {
    if (!pid) return;
    try {
      const { data } = await axios.get(`${API}/payments/${pid}`);
      setPayment(data);
    } catch { /* ignore */ }
  }, [pid]);

  useEffect(() => {
    poll();
    const id = setInterval(() => setTries((t) => t + 1), 2500);
    return () => clearInterval(id);
  }, [poll]);
  useEffect(() => { if (tries > 0 && tries < 8) poll(); }, [tries, poll]);

  const status = payment?.status;
  const paid = status === "paid";
  const failed = status === "failed" || status === "creation_failed";
  const pending = !status || status === "pending";

  return (
    <div dir="rtl" className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-body" data-testid="payment-result">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        {paid && (
          <>
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100">
              <CheckCircle2 className="h-9 w-9 text-emerald-600" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-slate-900" data-testid="payment-success">تمّت عملية الدفع بنجاح</h1>
            <p className="mt-1 text-slate-500">تم استلام مبلغ {(payment.amount_cents / 100).toLocaleString("en-US")} {payment.currency}</p>
          </>
        )}
        {failed && (
          <>
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-rose-100">
              <XCircle className="h-9 w-9 text-rose-600" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-slate-900" data-testid="payment-failed">تعذّرت عملية الدفع</h1>
            <p className="mt-1 text-slate-500">لم تكتمل العملية. يمكنك المحاولة مرة أخرى.</p>
          </>
        )}
        {pending && (
          <>
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
              {tries < 8 ? <Loader2 className="h-9 w-9 text-amber-600 animate-spin" /> : <Clock className="h-9 w-9 text-amber-600" />}
            </div>
            <h1 className="font-heading text-2xl font-bold text-slate-900">جارٍ تأكيد الدفع…</h1>
            <p className="mt-1 text-slate-500">نتحقق من حالة عمليتك، لحظات من فضلك.</p>
          </>
        )}
        <Button data-testid="payment-back-btn" onClick={() => navigate("/")} className="mt-6 w-full bg-blue-600 hover:bg-blue-700">العودة للرئيسية</Button>
      </div>
    </div>
  );
}
